import type { PageAnalyticsStoreType } from './pageAnalyticsStore';
import type { InjectedPageAnalyticsProps } from './PageDataInjector';
import type { DateRangePayload } from './storeTypes';
import { buildDateRangeState } from './storeUtils';

export type PageAnalyticsActionType =
	| { type: 'RESET' }
	| { type: 'SET_DATE_RANGE'; payload: DateRangePayload };

export const buildInitialPageAnalyticsStore = (
	injectedProps?: InjectedPageAnalyticsProps,
): PageAnalyticsStoreType => {
	return {
		isAnyFilterUpdated: false,
		// real content fields will be injected as soon as possible
		contentId: injectedProps?.contentId ?? '',
		contentType: injectedProps?.contentType,
		contentCreatedDate: injectedProps?.contentCreatedDate,
		contentTitle: injectedProps?.contentTitle,
		...buildDateRangeState({ entityCreationDate: injectedProps?.contentCreatedDate }),
	};
};

export const pageAnalyticsReducer = (
	state: PageAnalyticsStoreType,
	action: PageAnalyticsActionType,
): PageAnalyticsStoreType => {
	switch (action.type) {
		case 'RESET': {
			return {
				...state,
				isAnyFilterUpdated: false,
				...buildDateRangeState({ entityCreationDate: state.contentCreatedDate }),
			};
		}

		case 'SET_DATE_RANGE': {
			return {
				...state,
				isAnyFilterUpdated: true,
				...buildDateRangeState({ payload: action.payload }),
			};
		}

		default:
			return state;
	}
};
